import decode from 'jwt-decode';

// Quem grava a chave é o setFleetNumDevicesBaggage do api-lib; a frota sai do token para não mandar a contagem de outra.
const FLEET_NUM_DEVICES_KEY = 'cobli-fleet-num-devices';
const ACCESS_TOKEN_KEY = 'cobli-access-token';

const currentFleetId = () => {
  try {
    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    return accessToken ? decode<{ fleetId?: string }>(accessToken).fleetId : undefined;
  } catch {
    return undefined;
  }
};

const fleetNumDevices = (fleetId: string) => {
  try {
    const cache: unknown = JSON.parse(localStorage.getItem(FLEET_NUM_DEVICES_KEY) ?? '{}');
    const value = cache && typeof cache === 'object' ? (cache as Record<string, unknown>)[fleetId] : undefined;
    return typeof value === 'number' ? value : undefined;
  } catch {
    return undefined;
  }
};

// O mesmo baggage do api-lib, para a observabilidade do backend ver o tamanho da frota também nas chamadas da camada nova.
export const openTelemetryBaggageHeaders = (): Record<string, string> => {
  const fleetId = currentFleetId();
  const numberOfDevices = fleetId ? fleetNumDevices(fleetId) : undefined;
  return numberOfDevices === undefined ? {} : { 'ot-baggage-cobli-fleet-num-devices': String(numberOfDevices) };
};
